
import React from 'react';
import { AdPerformanceData } from '@/types/statistics';
import { MegaphoneIcon, Eye, MousePointerClick, MessageSquare } from 'lucide-react';

interface AdPerformanceStatsProps {
  data: AdPerformanceData;
}

const AdPerformanceStats: React.FC<AdPerformanceStatsProps> = ({ data }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="flex flex-col items-center justify-center p-4 bg-muted/30 rounded-lg">
          <Eye className="h-8 w-8 text-purple-500 mb-2" />
          <span className="text-sm text-muted-foreground">Total Impressions</span>
          <span className="text-2xl font-bold">{data.totalImpressions.toLocaleString()}</span>
        </div>
        <div className="flex flex-col items-center justify-center p-4 bg-muted/30 rounded-lg">
          <MousePointerClick className="h-8 w-8 text-blue-500 mb-2" />
          <span className="text-sm text-muted-foreground">Total Clicks</span>
          <span className="text-2xl font-bold">{data.totalClicks.toLocaleString()}</span>
        </div>
        <div className="flex flex-col items-center justify-center p-4 bg-muted/30 rounded-lg">
          <MessageSquare className="h-8 w-8 text-amber-500 mb-2" />
          <span className="text-sm text-muted-foreground">Total Inquiries</span>
          <span className="text-2xl font-bold">{data.totalInquiries.toLocaleString()}</span>
        </div>
      </div>
      
      <h3 className="text-lg font-medium mt-6 mb-4">Performance by Ad Type</h3>
      <div className="space-y-4">
        {data.byAdType.map((adType, index) => (
          <div key={index} className="border rounded-lg p-4">
            <div className="flex items-center gap-2 mb-3">
              <MegaphoneIcon className="h-5 w-5 text-primary" />
              <h4 className="text-md font-medium">{adType.type}</h4>
            </div>
            <div className="grid grid-cols-3 gap-2 text-center">
              <div>
                <p className="text-xs text-muted-foreground">Impressions</p>
                <p className="font-medium">{adType.impressions.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Clicks</p>
                <p className="font-medium">{adType.clicks.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Inquiries</p>
                <p className="font-medium">{adType.inquiries.toLocaleString()}</p>
              </div>
            </div>
            <div className="mt-2">
              <p className="text-xs text-muted-foreground">Conversion Rate</p>
              <div className="mt-1 h-2 w-full bg-muted rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary rounded-full"
                  style={{ width: `${adType.conversionRate}%` }}
                ></div>
              </div>
              <p className="text-xs text-right mt-1">{adType.conversionRate}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdPerformanceStats;
